import createResourceSelectors from 'store/utils/createResourceSelectors'

export default createResourceSelectors('messages', {
  getUnreadMessagesCount: state => state.resources.messages.unread
})
